import { useEffect, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { setDeviceMode, setSummitMode } from '../ActionCreators'
import { MODES } from '../Reducer'
import { useDispatch, useSelector } from 'react-redux'
import { sendCfdWebViewLoaded } from '../../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import { isCFDMode, isSummitMode, isE700Device, isSDKCompatible } from '../../VNAndroidSDK/Utils'
import { getDeviceMode } from '../Selectors'
import { setPosDeviceType } from '../../actions/peripheral'
import { POS_DEVICE_TYPES } from '../../utils/deviceData'
import { getAndroidSDKVersion } from '../../VNAndroidSDK/Selectors'

export const MIN_SUMMIT_APK_VERSION = '2.21.0'

export const VNModeSelect = () => {
  const history = useHistory()
  const dispatch = useDispatch()

  const cfdModeState = useSelector((state) => getDeviceMode(state))

  const androidSDKVersion = useSelector(getAndroidSDKVersion)
  const isSummitBuild = useMemo(() => {
    // use APK Version as determining factor if the device is summit capable
    if (isSDKCompatible(androidSDKVersion, MIN_SUMMIT_APK_VERSION)) {
      return true
    }

    // use URL query param as fallback for web testing
    return isSummitMode()
  }, [androidSDKVersion])

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    // handle routing without query params for device set to CFD mode
    if (urlParams.get('cfd') === null && cfdModeState === MODES.CFD) {
      sendCfdWebViewLoaded(false)
      history.replace('/customer-facing-display')
      return
    }

    if (isCFDMode()) {
      dispatch(setDeviceMode(MODES.CFD))
      sendCfdWebViewLoaded(false)
      history.replace('/customer-facing-display')
      return
    }

    if (isSummitBuild) {
      // set the summit mode in the full reducer so we can use it in other components
      dispatch(setSummitMode(true))
    }

    if (isE700Device()) {
      dispatch(setPosDeviceType(POS_DEVICE_TYPES.E700))
    }

    history.replace('/device-login')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
